{
    "tenants": {
        "title": "Tenants",
		"addTenant": "Add Tenant",
		"companyName": "Company Name",
		"tenantAlias": "Tenant Alias",
		"email": "Email",
		"tier": "Tier",
		"status": "Status",
		"type": "Type",
		"address": "Address",
		"phone": "Phone",
		"adminEmail": "Admin Email",
		"billingEmail": "Billing Email",
		"tenantType": "Tenant Type",
		"tenantApps": "Tenant Apps",
		"tenantLabel": "Tenant",
		"smsMfa": "SMS MFA",
		"newTenant": "New Tenant",
		"editTenant": "Edit Tenant",
		"active": "Active",
		"inactive": "Inactive",
		"enabled": "Enabled",
		"disabled": "Disabled",
		"tenantUsers": "Tenant Users",
        "validation": {
            "companyNameRequired": "Company name is required",
            "addressRequired": "Address is required",
            "addressMaxLength": "Address must not exceed 100 characters",
            "phoneRequired": "Phone is required",
            "phoneInvalid": "Please enter a valid phone number",
            "adminEmailRequired": "Admin email is required",
            "adminEmailInvalid": "Please enter a valid admin email",
            "billingEmailInvalid": "Please enter a valid billing email",
			"billingEmailRequired": "Billing email is required",
			"tierRequired": "Tier is required",
			"tenantTypeRequired": "Tenant type is required",
			"dedicatedIpHostnameRequired": "Hostname is required when dedicated IP is enabled",
			"dedicatedIpHostnameInvalid": "Please enter a valid hostname (e.g. eu-west-dedicated-02.quotaguard.com)",
			"dedicatedIpEgressIpRequired": "Egress IP is required when dedicated IP is enabled",
			"dedicatedIpEgressIpInvalid": "Please enter a valid IPv4 address (e.g. 192.168.1.1)",
			"dedicatedIpUsernameRequired": "Username is required when dedicated IP is enabled",
			"dedicatedIpPasswordRequired": "Password is required when dedicated IP is enabled",
			"dedicatedIpPortRequired": "Port is required when dedicated IP is enabled",
			"dedicatedIpPortInvalid": "Please enter a valid port number (1–65535)",
			"dedicatedIpProtocolRequired": "Protocol is required",
			"dedicatedIpProtocolDuplicate": "Protocol must be unique across ports"
        },
		"options": {
			"manageTenant": "Manage Tenant",
			"manageTenantUsers": "Manage Tenant Users",
			"promoteToAdmin": "Promote to Live Admin",
			"adminRoleNoActions": "Admin role — no actions available",
			"reindexEntities": "Re-index entities"
		},
		"messages": {
			"loadError": "Error loading tenant data",
			"deactivateTenantConfirmation": "Are you sure you want to deactivate '{tenantName}' tenant?",
			"statusUpdateSuccess": "Tenant status updated successfully",
			"statusUpdateError": "Error updating tenant status",
			"saveSuccess": "Tenant details are being saved. This may take a moment…",
			"saveError": "Error saving tenant details",
			"tenantUserGroupUpdated": "User group updated successfully",
			"tenantUserGroupUpdateError": "Error updating user group",
			"confirmPromoteToAdmin": "Are you sure you want to promote {user} to administrator?",
			"reindexSuccess": "Re-indexing queued for {count} entities",
			"reindexError": "Error starting re-index"
		},
		"reindex": {
			"title": "Re-index entities",
			"description": "Select an entity type to re-index for tenant '{tenantName}'.",
			"selectEntity": "Select an entity",
			"confirm": "Re-index"
		},
		"dedicatedIp": {
			"title": "Dedicated IPs",
			"enable": "Use Dedicated IP",
			"proxyHostname": "Proxy Hostname",
			"port": "Port",
			"listeningPorts": "Listening Ports",
			"selectService": "Select protocol",
			"username": "Username",
			"usernamePlaceholder": "proxy-username",
			"password": "Password",
			"passwordPlaceholder": "••••••••",
			"passwordSet": "Password is set ✓",
			"passwordChangePlaceholder": "Leave blank to keep existing password",
			"egressIp1": "Egress IP 1",
			"egressIp2": "Egress IP 2"
		},
		"tenantTypes": {
			"SYSADMIN": "Live Admin",
			"TENANT": "Tenant Admin"
		},
		"tiers": {
			"FREE": "Free",
			"ENTERPRISE": "Enterprise",
			"PRO": "Pro"
		},
		"resource": {
			"tenant": "Tenant"
		}
    }
}
